export const KIBANA_CONFIG_SAVE = 'src/Admin/Corporate/DIYReportSetup/action/Kibana_Config_Save';
export const KIBANA_CONFIG_SAVE_SUCCESS = 'src/Admin/Corporate/DIYReportSetup/action/Kibana_Config_Save_Success';
export const KIBANA_CONFIG_SAVE_FAILURE = 'src/Admin/Corporate/DIYReportSetup/action/Kibana_Config_Save_Failure';

export const setKibanaConfig = (data) => {
    return {
        type: KIBANA_CONFIG_SAVE,
        data
    }
}
export const setKibanaConfigSuccess = (data) => {
    return {
        type: KIBANA_CONFIG_SAVE_SUCCESS,
        data
    }
}
export const setKibanaConfigFailure = (data) => {
    return {
        type: KIBANA_CONFIG_SAVE_FAILURE,
        data
    }
}

export const DOWNLOAD_KEY_EXTRACTION = 'src/Admin/Corporate/DIYReportSetup/action/Download_Key_Extraction';
export const DOWNLOAD_KEY_EXTRACTION_SUCCESS = 'src/Admin/Corporate/DIYReportSetup/action/Download_Key_Extraction_Success';
export const DOWNLOAD_KEY_EXTRACTION_FAILURE = 'src/Admin/Corporate/DIYReportSetup/action/Download_Key_Extraction_Failure';

export const downloadKeyExtraction = (data) => {
    return {
        type: DOWNLOAD_KEY_EXTRACTION,
        data
    }
}

export const downloadKeyExtractionSuccess = (data) => {
    return {
        type: DOWNLOAD_KEY_EXTRACTION_SUCCESS,
        data
    }
}

export const downloadKeyExtractionFailure = (data) => {
    return {
        type: DOWNLOAD_KEY_EXTRACTION_FAILURE,
        data
    }
}